import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client'
import { FC, useEffect, useState } from 'react';
import powerBiService from '@/projects/platform/services/power-bi-report';
import { ReportResponse } from '../response/response';

type PowerBiReportProps = {
    reportName: string,
}


const NewPowerBiReports: FC<PowerBiReportProps> = ({ reportName }) => {

    const [zoomLevel, setZoomLevel] = useState(1);
    const [reportData, setReportData] = useState<ReportResponse | null>(null);
    const [activePage, setActivePage] = useState<String>("Dashboard");

    const handleResize = () => {
        const width = window.innerWidth;

        var newZoomLevel = width / 2400;

        if(activePage !== "Dashboard")
            newZoomLevel = (width / 2400)*1.62;

        setZoomLevel(newZoomLevel);
      };

    useEffect(() => {
    
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [activePage]);

    useEffect(() => {
        setReportData(null);
        const loadReportData = async () => {
            let reportResponse;
            if (reportName === 'new-power-bi-sales-performance-report') {
                reportResponse = await powerBiService.newGetSalesPerformanceReport();
            } else if (reportName === 'new-power-bi-live-sales-report') {
                reportResponse = await powerBiService.newGetLiveSalesReport();
            } else if (reportName === 'new-power-bi-stock-report') {
                reportResponse = await powerBiService.newGetStockReportReport();
            } else if (reportName === 'new-power-bi-bonibi-report') {
                reportResponse = await powerBiService.newGetBonibiReport();
            } else if (reportName === 'new-power-bi-philip-morris-sales-report') {
                reportResponse = await powerBiService.newGetSalesPerformanceReportPm();
            } else if (reportName === 'demo-power-bi-sales-performance-report') {
                reportResponse = await powerBiService.demoGetSalesPerformanceReport();
            } else if (reportName === 'demo-power-bi-live-sales-report') {
                reportResponse = await powerBiService.demoGetLiveSalesReport();
            } else if (reportName === 'demo-power-bi-stock-report') {
                reportResponse = await powerBiService.demoGetStockReport();
            }
            setReportData(reportResponse);
        };

        loadReportData();
    }, [reportName]);

    return (
        <>
            {reportData ? (
                <PowerBIEmbed
                    embedConfig={{
                        type: 'report',
                        id: reportData?.data?.embedReport.reportId,
                        embedUrl: reportData?.data?.embedReport.embedUrl,
                        accessToken: reportData?.data?.embedToken.token,
                        tokenType: models.TokenType.Embed,
                        settings: {
                            zoomLevel: zoomLevel,
                            panes: {
                                filters: {
                                    expanded: false,
                                    visible: false
                                }
                            },
                            background: models.BackgroundType.Default,
                        }
                    }}

                    eventHandlers={
                        new Map([
                            ['loaded', function () { console.log('Report loaded'); }],
                            ['rendered', function () { console.log('Report rendered'); }],
                            ['error', function (event: any) { console.log(event.detail); }],
                            ['visualClicked', () => console.log('visual clicked')],
                            ['pageChanged', (event: any) => {setActivePage(event.detail.newPage.displayName); }],
                        ])
                    }

                    cssClassName={"embed-container"}

                    getEmbeddedComponent={(embeddedReport: any) => {
                        // console.log(embeddedReport);
                    }}
                />

            ) : null}
        </>
    );
}


export default NewPowerBiReports;